import { render, staticRenderFns } from "./PodaciFirme.vue?vue&type=template&id=44357b6f&"
import script from "./PodaciFirme.vue?vue&type=script&lang=ts&"
export * from "./PodaciFirme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports